export type OutlineColor = "red" | "deep-orange" | "light-green" | "cyan" 

export const OUTLINE_COLOR_RED: OutlineColor = "red"
export const OUTLINE_COLOR_ORANGE: OutlineColor = "deep-orange"
export const OUTLINE_COLOR_GREEN: OutlineColor = "light-green"
export const OUTLINE_COLOR_BLUE: OutlineColor = "cyan"